import React from 'react'

import { Tooltip } from '@sketch/components'

import { ReactComponent as StarIcon } from '@sketch/icons/star-16'

import useVersionStarUnstar from '../../hooks/useVersionStarUnstar'
import { Wrapper, Button } from './StarVersion.styles'

const STAR_TEXT = {
  false: 'Unstarred Version',
  true: 'Starred Version',
}

const STAR_TOOLTIP_TEXT = {
  false: 'Star this Version',
  true: 'Unstar this Version',
} as const

interface StarVersionProps {
  isNewLatest: boolean
  versionIdentifier: string
  versionDescription?: string
  shareIdentifier: string
  isLibrary: boolean
  starred: boolean
}

interface StarProps {
  starred: boolean
}

interface StarButtonProps extends StarProps {
  onStarClick?: () => void
}

export const Star = ({ starred }: StarProps) => (
  <Wrapper data-testid="version-star">
    <StarIcon role="img" />
    <span className="sr-only">{STAR_TEXT[`${starred}` as const]}</span>
  </Wrapper>
)

const StarButton: React.FC<StarButtonProps> = props => (
  <Button
    data-testid="version-star-button"
    onClick={event => {
      event.preventDefault()
      props.onStarClick?.()
    }}
  >
    <Star starred={props.starred} />
  </Button>
)

const StarVersion: React.FC<StarVersionProps> = props => {
  const {
    isNewLatest,
    versionIdentifier,
    versionDescription,
    isLibrary,
    starred,
    shareIdentifier,
  } = props

  const starUnstarVersion = useVersionStarUnstar({
    isNewLatest,
    versionIdentifier,
    versionDescription,
    shareIdentifier,
    isLibrary,
  })

  return (
    <Tooltip
      content={STAR_TOOLTIP_TEXT[`${starred}` as const]}
      placement="bottom"
    >
      <StarButton
        starred={starred}
        onStarClick={() => {
          starUnstarVersion(starred)
        }}
      />
    </Tooltip>
  )
}

export default StarVersion
